import { Component, Input, Output, OnDestroy, NgZone, EventEmitter, ElementRef, ViewEncapsulation, ChangeDetectionStrategy, ViewChild, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalstateService } from 'src/app/services/modalstate.service';
import { VideoModalService, VideoModalState } from 'src/app/services/video-modal.service';
import { Item } from 'src/app/models/liveshop';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { StoreService } from 'src/app/services/store.service';
import { LitPlayerEmbedBridgeService, LitPlayerEmbedHandle } from 'src/app/services/lit-player-embed-bridge.service';
interface VideoItem {
  uid: string;
  id: number;
  src: string;
  poster: string;
  thumbnail?: string;
  products?: any[];
}

@Component({
  selector: 'app-video-modal',
  standalone: true,
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  encapsulation: ViewEncapsulation.Emulated,
  host: {
    '[class.ss-widget-build]': 'isWidgetBuild'
  },
  providers: [

  ]
})
export class VideoModalComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  //////////////////
  private originalParent?: Node;
  private originalNextSibling?: Node | null;
  private mountedInBody = false;

  private mountHostToBody(): void {
    const hostEl = this.host?.nativeElement as HTMLElement;
    if (!hostEl || this.mountedInBody) return;

    this.originalParent = hostEl.parentNode ?? undefined;
    this.originalNextSibling = hostEl.nextSibling;

    document.body.appendChild(hostEl);
    this.mountedInBody = true;
  }

  private restoreHostToOriginalPlace(): void {
    const hostEl = this.host?.nativeElement as HTMLElement;
    if (!hostEl || !this.mountedInBody || !this.originalParent) return;

    if (this.originalNextSibling) {
      this.originalParent.insertBefore(hostEl, this.originalNextSibling);
    } else {
      this.originalParent.appendChild(hostEl);
    }

    this.mountedInBody = false;
  }
  //////////////////

  @Input() arraySlicksFull: Item[] = []; // Array completo de slicks isAdmin
  @Input() videoUrls: VideoItem[] = [];  // URLs dos vídeos recebidos do componente pai
  @Input() show: boolean = false;                  // Controla a visibilidade do modal
  @Input() isAdmin: boolean = true;
  @Input() selectedVideo?: VideoItem;    // Vídeo selecionado
  @Output() close = new EventEmitter<void>(); // Evento para fechar o modal
  @Input() totalAssets: number = 0;
  @Input() widget_id?: number;
  @Input() store_id?: number;
  @Input() template_id?: number;
  @Input() height: number | undefined;
  @Input() pageToVideos: number = 0;
  @Input() instanceId?: string;
  aspectRatio: string | undefined;
  playerSlicks: Item[] = [];
  private playerInitialized = false;
  private worker?: Worker;
  private modalStateSubscription?: Subscription;
  private isServiceControlled = false;

  // Iframe do player Lit — criado UMA VEZ (`ngOnInit()`) e mantido vivo
  // entre aberturas (nunca recriado a cada clique, ver plano em memória
  // `plan_lit_player_iframe_embed.md`). Só o `<slicksell-player>` DE DENTRO
  // do iframe é recriado a cada abertura (via `bridge.init()`), igual o
  // widget real já faz (`slicksell-widget.ts::handleTemplateItemClick`).
  @ViewChild('iframeHost', { static: true }) iframeHost!: ElementRef<HTMLElement>;
  private bridge?: LitPlayerEmbedHandle;
  private loadMorePage = 1;
  private loadMoreLoadedCount = 0;
  private loadMoreHasMore = true;

  isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // web componente selectedVideo videoUrls
  @Input('video-urls') set setVideoUrls(value: VideoItem[]) {
    this.videoUrls = value;
  }

  @Input('selected-video') set setSelectedVideo(value: VideoItem | undefined) {
    this.selectedVideo = value;
  }

  @Input('array-slicks-full') set setArraySlicksFull(value: Item[]) {
    this.arraySlicksFull = value;
  }

  @Input('page-to-videos') set setPageToVideos(value: number) {
    this.pageToVideos = value;
  }

  @Input('template-id') set setTemplateId(value: number | undefined) {
    this.template_id = value;
  }

  @Input('store-id') set setStoreId(value: number | undefined) {
    this.store_id = value;
  }

  @Input('aspect-ratio') set setAspectRatio(value: any) {
    this.aspectRatio = value;
  }

  showModal() {
    this.show = true;
  }

  // web componente


  isPlayerVisible = false;


  constructor(
    private modalStateService: ModalstateService,
    private cdr: ChangeDetectorRef,
    private host: ElementRef,
    private ngZone: NgZone,
    private videoModalService: VideoModalService,
    private storeService: StoreService,
    private embedBridgeService: LitPlayerEmbedBridgeService
  ) { }
  readonly isWidgetBuild = environment.isWidgetBuild;
  private isWebComponent: boolean = false;

  private mutationObserver?: MutationObserver;
  ngOnInit(): void {
    console.log('V1.0')

    this.bridge = this.embedBridgeService.createIframe(this.iframeHost.nativeElement);
    this.bridge.onRequestMore = () => this.loadMorePlayerSlides();
    this.bridge.onCloseRequested = () => this.closeModal();

    this.isWebComponent = !!document.querySelector('video-modal-widget');
    this.aspectRatio = '16/9';
    document.addEventListener('keyup', this.handleKeyUp);

    if (this.isWebComponent) {
      (this.host.nativeElement as any).showModal = this.showModal.bind(this);

      this.mutationObserver = new MutationObserver(() => {
        this.ngZone.run(() => {                // 👈 observer também está fora da zone
          this.syncAttributes();
        });
      });

      this.mutationObserver.observe(this.host.nativeElement, { attributes: true });
    }

    if (!this.instanceId) {
      const attrId = (this.host.nativeElement as HTMLElement).getAttribute('instance-id');
      if (attrId) {
        this.instanceId = attrId;
      }
    }

    this.modalStateSubscription = this.videoModalService.state$
      .pipe(
        filter((state) => {
          if (state.instanceId) {
            return !!this.instanceId && state.instanceId === this.instanceId;
          }
          return !this.instanceId;
        })
      )
      .subscribe((state) => {
        void this.applyServiceState(state);
      });
  }

  ngAfterViewInit(): void {
  }

  private syncAttributes() {
    const element = this.host.nativeElement as any;

    this.isAdmin = element.getAttribute('is-admin') === 'true';
    this.widget_id = Number(element.getAttribute('widget-id')) || undefined;
    this.height = Number(element.getAttribute('height')) || undefined;
    this.totalAssets = Number(element.getAttribute('total-assets')) || 0;
    this.show = element.getAttribute('show') === 'true';
    const attrInstance = element.getAttribute('instance-id');
    if (attrInstance) {
      this.instanceId = attrInstance;
    }

    this.cdr.detectChanges();
  }
  private handleKeyUp = (event: KeyboardEvent): void => {
    if (event.key === 'Escape' && this.isPlayerVisible) {
      this.closeModal();
    }
  };

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (this.isServiceControlled) {
      return;
    }
    console.log('em ngOnChanges')
    if (changes['show']) {
      console.log('em changes show')
      this.cdr.detectChanges();
      if (changes['show'].currentValue && this.show) {
        console.log('em changes show 1')
        // await this.sortSlicksAndSendToPlayer();
        // await this.setupSrcs();
      }
    }
  }

  private async applyServiceState(state: VideoModalState): Promise<void> {
    console.log('[VideoModalComponent] applyServiceState()', {
      show: state.show,
      selectedVideo: state.selectedVideo,
      slicksLength: state.slicks?.length ?? 0,
      sampleSlick: state.slicks?.[0],
      totalAssets: state.totalAssets,
      widgetId: state.widgetId,
      storeId: state.storeId,
      templateId: state.templateId,
      height: state.height,
      pageToVideos: state.pageToVideos
    });
    console.log('[VideoModalComponent] slicks received', state.slicks);
    if (!state.show || !state.selectedVideo) {
      if (this.isServiceControlled) {
        this.isServiceControlled = false;
        this.show = false;
        this.isPlayerVisible = false;
        this.playerInitialized = false;
        this.selectedVideo = undefined;
        this.playerSlicks = [];
        this.teardownPlayer();
        this.cdr.markForCheck();
      }
      return;
    }

    this.isServiceControlled = true;
    this.show = true;
    this.isPlayerVisible = true;
    //this.mountHostToBody(); // novo
    this.selectedVideo = state.selectedVideo;
    this.videoUrls = [state.selectedVideo];
    this.isAdmin = state.isAdmin;
    this.widget_id = state.widgetId;
    this.store_id = state.storeId ?? this.store_id;
    this.template_id = state.templateId;
    this.height = state.height;
    this.totalAssets = state.totalAssets;
    this.pageToVideos = state.pageToVideos ?? this.pageToVideos;
    this.arraySlicksFull = state.slicks ?? this.arraySlicksFull;

    await this.setupSrcs();
    this.cdr.markForCheck();
  }

  private transformVideoToSlick(video: VideoItem): Item[] {
    console.log('video em transformVideoToSlick')
    console.log(video)
    return [
      {
        schedule: {
          date_from: new Date().toISOString(),  // Define a data atual ou ajuste conforme necessário
          date_to: null  // Ou defina uma data se necessário
        },
        media: {
          type: 'video',  // Ajuste conforme necessário
          src: video.src,
          pin: 0,  // Valor padrão ou ajuste conforme a regra de negócio
          time_to_pitch: '',
          thumbnail: video.thumbnail || null,
          duration: null,  // Ajuste se necessário
          stream_status: null,
          status: 1,  // Ajuste conforme a lógica (ativo/inativo)
          aspect_ratio: '16/9'  // Ajuste conforme necessário
        },
        content: {
          id: video.id,
          uid: video.uid,
          title: 'Título Padrão1',
          description: 'Descrição Padrão',  // Defina uma descrição padrão ou ajuste conforme necessário
          cta: {
            components: {
              custom: [],
              whatsapp: [],
              products: {
                items: video.products || [],
              },
              promotions: {
                items: [],
              },
              links: [],
              extra: {
                ecom_layer: {
                  cart: { type: null, display: null, platform: null },
                  search_bar: { display: null },
                },
                chat_box: { display: { read: null, write: null } },
                promotions: { items: [] },
                player: {
                  auto_play: true,
                  show_progress_bar: false,
                  time_to_pitch: false,
                  time_to_pitch_value: '',
                  player_color: '#000000',
                  progress_bar_color: '#FFFFFF',
                },
                tags: '',
                profileBtn: true, // até pegar o valor correto do backend
              },
              alerts: [],
            },
          },
        },
        extra: {
          ecom_layer: {
            cart: { type: null, display: null, platform: null },
            search_bar: { display: null },
          },
          chat_box: { display: { read: null, write: null } },
          promotions: { items: [] },
          player: {
            auto_play: true,
            show_progress_bar: false,
            time_to_pitch: false,
            time_to_pitch_value: '',
            player_color: '#000000',
            progress_bar_color: '#FFFFFF',
          },
          tags: '',
          profileBtn: true, // até pegar o valor correto do backend
        },
        zIndex: 1
      }
    ];
  }



  workerBlob: Blob | null = null;
  workerBlobURL: string | null = null;
  private async sortSlicksAndSendToPlayer() {
    if (typeof Worker !== 'undefined' && this.videoUrls[0]?.uid) {
      console.log('entrou em sortSlicksAndSendToPlayer')
      this.workerBlob = new Blob([
        `
        self.addEventListener('message', ({ data }) => {
          const { slicks, targetUid } = data;

          const targetIndex = slicks.findIndex((item) => item?.content?.uid === targetUid);
          
          if (targetIndex === -1) {
            postMessage({ sorted: slicks, success: false }); 
          } else {
            const sortedSlicks = Array.from(slicks);
            const rotatedSlicks = sortedSlicks.slice(targetIndex).concat(sortedSlicks.slice(0, targetIndex));
            postMessage({ sorted: rotatedSlicks, success: true }); 
          }
        });
        `
      ], { type: 'application/javascript' });
      this.workerBlobURL = URL.createObjectURL(this.workerBlob);
      this.worker = new Worker(this.workerBlobURL);
      // return comentado
      return new Promise((resolve) => {
        if (!this.worker) {
          resolve(false);
          return;
        }

        this.worker.onmessage = ({ data }) => {
          //this.ngZone.run(() => {                         // 👈 entra na zone
          if (data.success) {
            this.arraySlicksFull = data.sorted;
            this.cdr.markForCheck();
            resolve(true);
          } else {
            console.error('Worker não encontrou o vídeo alvo');
            resolve(false);
          }
          //});
        };

        this.worker.onerror = (error) => {
          //this.ngZone.run(() => {                         // 👈 idem
          console.error('❌ Erro ao carregar produto do hotspot', error);
          resolve(false);
          //});
        };

        this.worker.postMessage({
          slicks: this.arraySlicksFull,
          targetUid: this.videoUrls[0].uid
        });
      });
    }
    return Promise.resolve(false);
  }
  private async setupSrcs() {
    if (!this.show) {
      return;
    }

    this.isPlayerVisible = true;
    this.cdr.detectChanges();

    const hasArraySlicks = Array.isArray(this.arraySlicksFull) && this.arraySlicksFull.length > 0;
    const fallbackSlicks = this.selectedVideo ? this.transformVideoToSlick(this.selectedVideo) : [];
    this.playerSlicks = hasArraySlicks ? this.arraySlicksFull : fallbackSlicks;
    this.arraySlicksFull = hasArraySlicks ? this.arraySlicksFull : this.playerSlicks;

    this.initPlayer();
  }

  // Manda `init` pro iframe (já vivo desde `ngOnInit()`) — troca o
  // `<slicksell-player>` de dentro por um novo, com os dados desta
  // abertura. `Item` (Angular) e `SlicksellAssetItem` (Lit) são
  // estruturalmente a mesma coisa (`{schedule, media, media_creator,
  // content, extra}`, mesmo `LiveShopAssetResource` do backend) — os itens
  // são repassados DIRETO por postMessage, sem transformação.
  private initPlayer(): void {
    if (!this.arraySlicksFull?.length || !this.store_id) return;

    this.loadMorePage = 1;
    this.loadMoreLoadedCount = this.arraySlicksFull.length;
    this.loadMoreHasMore = this.loadMoreLoadedCount < this.totalAssets;

    const initialAssetPosition = Math.max(
      0,
      this.arraySlicksFull.findIndex((item) => item.content?.uid === this.selectedVideo?.uid)
    );

    void this.bridge?.init({
      items: this.arraySlicksFull,
      totalAssets: this.totalAssets,
      storeId: this.store_id,
      widgetId: this.widget_id ?? 0,
      initialAssetPosition,
      sessionId: this.ensureSessionId(),
      playerSessionId: this.ensurePlayerSessionId()
    });
  }

  private loadMorePlayerSlides(): void {
    if (!this.loadMoreHasMore || !this.widget_id) return;
    this.loadMorePage += 1;

    this.storeService.listarAssetsWidgetPublic(this.widget_id, this.loadMorePage, 10, this.store_id).subscribe({
      next: async (res: any) => {
        this.totalAssets = res.totalAssets ?? this.totalAssets;
        const rawItems = (res.assets ?? []).flatMap((asset: any) => asset.items);
        this.loadMoreLoadedCount += rawItems.length;
        this.loadMoreHasMore = this.loadMoreLoadedCount < this.totalAssets;

        await this.bridge?.appendItems({ items: rawItems, totalAssets: this.totalAssets });
      },
      error: () => {
        // Silencioso — mesmo comportamento do loadMore original.
      }
    });
  }

  // Mesmas chaves de localStorage/sessionStorage que `slicksell-widget.ts`
  // (`ensureSessionId()`/`ensurePlayerSessionId()`) já usa no player real.
  private generateUID(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  private ensureSessionId(): string {
    const stored = sessionStorage.getItem('ss_session_id');
    if (stored) return stored;
    const generated = this.generateUID();
    sessionStorage.setItem('ss_session_id', generated);
    return generated;
  }

  private ensurePlayerSessionId(): string {
    const stored = localStorage.getItem('ss_player_session_id');
    if (stored) return stored;
    const generated = this.generateUID();
    localStorage.setItem('ss_player_session_id', generated);
    return generated;
  }

  // Fechamento (X do player via `onCloseRequested`, X externo, ou o
  // serviço mandando `show:false`) — derruba o `<slicksell-player>` de
  // dentro do iframe NA HORA, sem esperar a próxima abertura mandar um
  // `init` novo (senão ele ficaria rodando escondido, gastando recurso à
  // toa, entre um fechamento e a próxima abertura).
  private teardownPlayer(): void {
    void this.bridge?.teardown();
  }

  private isSorting = false;

  closeModal() {
    this.teardownPlayer();

    this.playerSlicks = [];
    this.selectedVideo = undefined;
    this.playerInitialized = false;
    this.cdr.detectChanges();

    this.isPlayerVisible = false;
    this.playerSlicks = [];
    this.selectedVideo = undefined;
    this.playerInitialized = false;
    this.cdr.detectChanges();

    this.isSorting = false;
    this.videoModalService.close(this.instanceId);
    this.close.emit();
    //this.restoreHostToOriginalPlace(); // novo

    this.isPlayerVisible = false;
    this.playerInitialized = false;

    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = undefined;
    }

    this.worker?.terminate();
    this.worker = undefined;

    if (this.workerBlobURL) {
      URL.revokeObjectURL(this.workerBlobURL);
      this.workerBlobURL = null;
    }
  }

  private cleanupDOM() {
    // Player criado estaticamente; nada para limpar aqui
  }

  ngOnDestroy(): void {
    this.modalStateSubscription?.unsubscribe();
    this.bridge?.destroy();

    // 1️⃣ Finalizar o Web Worker (se estiver ativo)
    if (this.worker) {
      this.worker.terminate();
      this.worker = undefined;
    }

    // 🔹 Desconectar o MutationObserver
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = undefined;
    }

    // 2️⃣ Revogar o URL do Blob
    if (this.workerBlobURL) {
      URL.revokeObjectURL(this.workerBlobURL);
      this.workerBlobURL = null;
    }

    if (this.mountedInBody) {
      //this.restoreHostToOriginalPlace();
    }

    this.playerInitialized = false;
    this.playerSlicks = [];
    this.isPlayerVisible = false;
    this.cleanupDOM();

  }


}
